import axios from 'axios';
// import {IQ_API_V2_BASE_URL} from '../config/apiConfig';
import api from './api';
import { IQ_AUTO_NURTURE_API_BASE_URL } from '../config/apiConfig';


const iq_auto_nurture_api = axios.create({
  baseURL: IQ_AUTO_NURTURE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Add a request interceptor
iq_auto_nurture_api.interceptors.request.use(
  config => {
    // You can modify the config before sending the request, like adding authorization token
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log('Request:', config); // Log the request for debugging
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
iq_auto_nurture_api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      switch (error.response.status) {
        case 401:
          // Handle unauthorized access (e.g., redirect to login)
          console.error('Unauthorized access - perhaps redirect to login');
          break;
        case 403:
          // Handle forbidden access
          console.error('Forbidden access');
          break;
        case 404:
          // Handle not found
          console.error('Resource not found');
          break;
        case 500:
          // Handle internal server error
          console.error('Internal server error');
          break;
        default:
          // Handle other status codes
          console.error(`Error: ${error.response.status}`, error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error', error.message);
    }

    // Return a rejected promise to propagate the error
    return Promise.reject(error);
  }
);

export const getFuncHere = async () => {
    try {
      const response = await api.get("/chat/test_func_call", {});
      // console.log(response);
      if (response.status === 201 || response.status === 200) {
        return response.data?.data || [];
        // console.log("response.data?.data || [] ", response.data?.data || [])
      } else {
      }
    } catch (err) {
       return null;
    }
    return;
};



export default iq_auto_nurture_api;
